import React, { FC } from 'react';
import Form from 'components/Form';

import { MorteinPageProps } from './models';

import 'styles/main.scss';
import './styles.scss';

const Mortein: FC<MorteinPageProps> = ({ pageContext, location }) => (
  <Form {...{ ...pageContext, location }} />
);

export default Mortein;
